// Browser tab titles, keyed by the route's path pattern (as written in router/index.js).
// Paths that read an id from the query (e.g. ?keywordId=) use one title for create and edit.
const TITLES = {
  '/summary': 'Dashboard',
  '/createadmin': 'Create Admin',
  '/notifications': 'Notifications',

  '/conversation/view': 'Conversations',
  '/conversation/create': 'Create Conversation',
  '/conversation/update': 'Edit Conversation',
  '/nlp_topic_list': 'Topic-Conversation Mapping',
  '/nlp_topic_detail': 'Topic-Conversation Mapping',

  '/user-journey/view': 'User Journeys',
  '/user-journey/create': 'Create Journey',
  '/user-journey/update': 'Edit Journey',
  '/user-journey/create-new': 'AI Journey Builder',
  '/user-journey/settings': 'Journey Settings',
  '/scout_jor_list': 'Scout-JOR Mapping',
  '/scout_jor_detail': 'Scout-JOR Mapping',

  '/entry-points/create': 'Entry Points',
  '/content-calendar/calendar': 'Content Calendar',
  '/content-calendar/approvals': 'Content Approvals',

  '/keywords_list': 'Keywords',
  '/NewKeywordsDetails': 'Keyword Details',
  '/phrases_list': 'Phrases',
  '/PhrasesDetails': 'Phrase Details',

  '/messages-dashboard': 'App Messages',
  '/addOrUpdate': 'App Message Sheet',
  '/appmessageupdate': 'Edit App Message',
  '/appMessagedetails': 'App Message Details',

  '/prompt-management/view': 'Prompts',
  '/prompt-management/create': 'Create Prompt',
  '/prompt-management/update': 'Edit Prompt',

  '/media-management/view': 'Media',
  '/media-management/upload': 'Upload Media',

  '/resources-virtual': 'Virtual Resources',
  '/resources-physical': 'Physical Resources',
  '/virtual-resources-addOrUpdate': 'Virtual Resource',
  '/bulk-upload-physical-resources': 'Bulk Upload Resources',
  '/locate-resources': 'Locate Resources',

  '/offering-manager/view': 'Offerings',
  '/offering-manager/create': 'Create Offering',
  '/offering-manager/update': 'Edit Offering',

  '/customer-list': 'Customers',
  '/customer-addOrUpdate': 'Customer',

  '/link-list': 'Links',
  '/link-addOrUpdate': 'Link',

  '/opportunity-list': 'Database Marketing',
  '/opportunity': 'Create Opportunity',
  '/opportunity/:opportunityId?': 'Opportunity',
  '/opportunity/:opportunityId?/:action?': 'Opportunity',
  '/opportunity-report': 'Opportunity Report',
  '/dbm-reports': 'DBM Reports',

  '/nudge-console/dashboard': 'Nudge Console',
  '/nudge-console/create-campaign': 'Create Campaign',
  '/nudge-console/edit-campaign': 'Edit Campaign',
  '/nudge-console/analytics': 'Nudge Analytics',

  '/audience-builder/view': 'Audience Queries',
  '/audience-builder/create': 'Create Audience',
  '/audience-builder/update': 'Edit Audience',
  '/audience-builder/upload': 'Upload Audience',
  '/audience-builder/manage-folder': 'Audience Folders',
  '/audience-builder/ai-generate': 'AI Audience',

  '/nudge-template/view': 'Nudge Templates',
  '/nudge-template/create': 'Create Template',
  '/nudge-template/update': 'Edit Template',
  '/nudge-template/ai-create': 'AI Nudge Creation',

  '/reengagement-manager/view': 'Reengagement',
  '/reengagement-manager/create': 'Create Reengagement',
  '/reengagement-manager/:campaignId?': 'Reengagement Campaign',

  '/nudges': 'Push Notifications',
  '/new-nudge': 'Create Push Notification',
  '/nudge': 'Push Notification',

  '/user-upload/create': 'User Upload',
  '/file-upload/create': 'Files',

  '/auditing/symptoms': 'Audit · Symptoms',
  '/auditing/medications': 'Audit · Medications',
  '/auditing/chat-intent': 'Audit · Chat Intent',
  '/auditing/audit/:datasetId': 'Audit',
  '/auditing/evaluate/:datasetId': 'Evaluate'
}

// Tabs inside a page that the sidebar links to directly
const QUERY_TAB_TITLES = {
  '/entry-points/create': {
    'journey-defaults': 'Journey Defaults',
    'all-entry-points': 'All Entry Points'
  }
}

const APP_NAME = 'Nivi'

export function pageTitle (route) {
  const matched = route.matched[route.matched.length - 1]
  const pattern = matched ? matched.path : route.path
  const tabs = QUERY_TAB_TITLES[pattern]
  const title = (tabs && tabs[route.query.tab]) || TITLES[pattern]
  return title ? `${title} · ${APP_NAME}` : `${APP_NAME} Dashboard`
}



// WEBPACK FOOTER //
// ./src/router/pageTitles.js